﻿import Repository from "./Repository";

const notificationsResource = "notifications/notifications";
const resolveNotificationResource = "notifications/resolve";
const markAsReadResource = "notifications/markasread";

export default {
  getNotifications() {
    return Repository.get(notificationsResource);
  },
  resolveNotification(id) {
    var fd = new FormData();
    fd.append("id", id);
    return Repository.post(resolveNotificationResource, fd);
  },
  markAsRead(arrayOfIds) {
    var fd = new FormData();
    arrayOfIds.forEach((id) => {
      fd.append("notificationIds", id);
    });
    return Repository.post(markAsReadResource, fd);
  },
};
